import { connect } from 'react-redux'
import compose from 'recompose/compose'
import InteractiveElementsList from '../../components/2d/elements_list/InteractiveElementsList'
import {
    expandInteractiveElementsList,
    minimizeInteractiveElementsList,
    hideInteractiveElementsList,
} from '../../actions/interactiveElementsListActions'
import { InteractiveListStates } from '../../constants'
import React from 'react'
import onClickOutside from 'react-onclickoutside'
import withProps from 'recompose/withProps'
import { mainMedia } from 'aria-viewer/utils/functions'
import { MEDIA_TYPES } from 'aria-viewer/tour/constants'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'

const props = withProps(({ elements, visitedElements, mediaType }) => {
    const elementCount = (elements && elements.length) || 0
    const visitedElementCount = (visitedElements && visitedElements.length) || 0
    const displayElementList = visitedElementCount >= 1 && mediaType == MEDIA_TYPES.panorama
    // compute numDigits to determine how to set the font size of the list header
    const numDigits = `${elementCount}${visitedElementCount}`.length
    return {
        elementCount,
        visitedElementCount,
        numDigits,
        displayElementList,
    }
})

const mapStateToProps = state => {
    let els = []
    let visitedEls = []
    const stopId = state.getIn(['interactiveElements', 'currentScene', 'stopId'])
    const list = state.getIn(['interactiveElements', 'meta', 'totalElements', 'byStop', String(stopId)])
    els = list ? list.toJS() : []
    const visitedList = state.getIn(['interactiveElements', 'meta', 'visited', 'byStop', String(stopId)])
    visitedEls = visitedList ? visitedList.toJS() : []
    const stateProps = mapSelectorsToProps(['isDeviceMobile'])()(state)

    return {
        currentState: state.getIn(['interactiveElements', 'interactiveElementsListState']),
        elements: els,
        visitedElements: visitedEls,
        stopId,
        mediaType: mainMedia(state).mediaType,
        ...stateProps,
    }
}

const mapDispatchToProps = dispatch => ({
    handleOnToggleList: function(currentState) {
        if (currentState === InteractiveListStates.EXPANDED) {
            dispatch(minimizeInteractiveElementsList())
        } else if (currentState === InteractiveListStates.MINIMIZED) {
            dispatch(expandInteractiveElementsList())
        }
    },

    handleZeroVisited: function() {
        dispatch(hideInteractiveElementsList())
    },

    minimizeInteractiveElementsList: () => {
        dispatch(minimizeInteractiveElementsList())
    },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onToggleList: () => {
        dispatchProps.handleOnToggleList(stateProps.currentState)
    },
    onComponentDidMount: () => {
        if (stateProps.visitedElements.length === 0) {
            dispatchProps.handleZeroVisited()
        }
    },
    handleClickOutside: () => {
        if (stateProps.visitedElements.length > 0 && stateProps.currentState === InteractiveListStates.EXPANDED) {
            dispatchProps.minimizeInteractiveElementsList()
        }
    },
})

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    ),
    onClickOutside,
    props
)(InteractiveElementsList)
